import React from "react";
import { Link } from "react-router-dom";
import {
  ShoppingCart,
  Warehouse,
  Smartphone,
  Truck,
  Monitor,
  Home,
  MapPin,
  Users,
  Mailbox,
  ArrowRight,
} from "lucide-react";
import "./Products.css";

const products = [
  {
    id: "erp",
    title: "ERP",
    icon: <ShoppingCart size={32} />,
    description: "Streamline your procurement processes",
  },
  {
    id: "warehouse",
    title: "Warehouse",
    icon: <Warehouse size={32} />,
    description: "Advanced inventory management solutions",
  },
  {
    id: "mobile-solutions",
    title: "Mobile Solutions",
    icon: <Smartphone size={32} />,
    description: "Custom mobile applications for your business",
  },
  {
    id: "transport-logistics",
    title: "Transport & Logistics",
    icon: <Truck size={32} />,
    description: "Optimize your supply chain operations",
  },
  {
    id: "retail-pos",
    title: "Retail & POS",
    icon: <Monitor size={32} />,
    description: "Complete retail management systems",
  },

  {
    id: "gps-services",
    title: "GPS Services",
    icon: <MapPin size={32} />,
    description: "Real-time tracking and fleet management",
  },
  // {
  //   id: "postage-logistics",
  //   title: "Postage Logistics",
  //   icon: <Mailbox size={32} />,
  //   description: "Efficient mail and package management",
  // },
 
];

const Products = () => {
  return (
    <section id="products" className="products-section">
      <div className="products-container">
        <div className="section-header">
          <h2>
            Our <span>Product Solutions</span>
          </h2>
          <p>Specialized software for every business need</p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <Link
              to={`/products/${product.id}`}
              key={product.id}
              className="product-card"
            >
              <div className="product-icon">{product.icon}</div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <div className="learn-more">
                Learn more <ArrowRight size={16} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
